/** @import RegistrationData from '@/classes/facturae/RegistrationData' */
export default class Sociedad {
  /** @type {boolean} */ IsSeflInvoiceSociety = true
  /** @type {string} */ TIN = null
  /** @type {string} */ ResidenceType = null
  /** @type {string} */ PersonType = null
  /** @type {string} */ NameCorporateName = null
  /** @type {string} */ FirstSurname = null
  /** @type {string} */ SecondSurname = null
  /** @type {RegistrationData} */ RegistrationData = null
}
